import { AppController } from "../AppController";
var StartPage = /** @class */ (function () {
    function StartPage(_appController) {
        this._appController = _appController;
    }
    Object.defineProperty(StartPage.prototype, "appController", {
        get: function () {
            return this._appController;
        },
        enumerable: true,
        configurable: true
    });
    return StartPage;
}());
export { StartPage };
